<template lang="pug">
  main
    NavBarCORP
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.section-title
          .column.is-half.is-offset-one-quarter.has-text-centered.has-text-dark
            h1.title Solicitar un cambio en el documento
            a.button.is-black.is-rounded(@click="backPage")
              i.fas.fa-times

        .card
          .card-content
            .card-header|
              .card-header-title
                h5.subtitle title

            .card-body(v-if="true")
              |content




        input#fileInput(type="file" style="display: none" @change="handleFileChange")
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarCORP from '@/components/layout/NavBarCorpo.vue'
import sasisopaAPI from "@/services/axios_sasisopa.js";

export default {
  name: 'ChangeRequest',
  components: { Loader, NavBarCORP },
  data () {
    return {
      isLoading: false,
      documents: [],

    }
  },
  methods: {
    async fetchData() {
      try {
        this.isLoading = true;
        const response = await sasisopaAPI.getFile(this.$route.params.id);
        // const response = JSON.parse(responseTxt.split('\n').slice(1).join('\n'))
        this.documents = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.isLoading = false;
      }
    },

    backPage() {
      this.$router.back();
    },
    sendResponse() {
      this.$router.push(`/SASISOPA/solicitud-cambio/${this.$route.params.id}`);
    },

    obtenerUser() {
    }
  },
  created () {
    this.$store.commit('irEstaciones', 'CORP');
    this.obtenerUser();
    this.fetchData();
  }
}
</script>

<style lang="css" scoped>
.card {
  border-radius: 8px;
  box-shadow: 0 4px 8px #c7c7c71f;
}

.circulitos {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.circulito {
  display: flex;
  background-color: #ffffff;
  color: #057D8D;
  border-color: #8d0505;
  border: solid;
  border-radius: 50%;
  padding: 0.5rem;
  text-align: center;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  margin: 1rem;
}
.selected{
background-color: #057D8D;
  color: #fff;
   cursor: pointer;
}

.card-header {
  margin-bottom: 1rem;
}

.card-body {
  margin-bottom: 1rem;
}

.archivo iframe {
  width: 100%;
  height: 600px;
}

.input {
  margin-top: 1rem;
}

.input textarea {
  width: 100%;
  height: 100px;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.respuestas {
  margin-top: 1rem;
}

.respuestas div {
  margin-bottom: 0.5rem;
}

.respuestas input {
  width: calc(100% - 90px);
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.respuestas button {
  width: 80px;
  margin-left: 10px;
}
.iframe-container {
  position: relative;
  width: 100%;
  height: 600px; /* O el tamaño que necesites */
}

.iframe-container iframe {
  width: 100%;
  height: 100%;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 24.3%;
  height: 14.5%;
  background: rgba(30, 35, 63, 0);
  pointer-events: auto;
  z-index: 10;
  cursor: no-drop;
  margin-left: 75%;
}

.flip-vertical {
            transform: scaleX(-1);
            display: inline-block; /* Asegúrate de que el ícono tenga un bloque en línea */
        }

</style>



// WEBPACK FOOTER //
// src/components/sasisopa/ChangeRequest.vue